// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__184jC","col":"styles_col__jEAz_"};